import EventService from "../../services/EventService";
import { indexById } from "../../components/Utils";

export const namespaced = true;


export const state = {
    loading: 0,
    videos: [],
    byId: {}
};

export const mutations = {
    SET_LOADING(state, percent) {
        state.loading = percent;
    },
    SET_VIDEOS(state, videos) {
        state.videos = videos;
    },
    SET_BYID(state, indexed) {
        state.byId = indexed;
    }
};

export const actions = {
    async fetchLiveVideos(context) {
        return EventService.getLiveVideos()
            .then(response => {
                context.commit('SET_LOADING', 50);
                context.commit('SET_VIDEOS', response.data);
                context.commit('SET_BYID', indexById(response.data));
            })
            .catch(error => {
               console.log('getLiveVideos failed: ', error.message)
            })
            .finally(() => {
                context.commit('SET_LOADING', 100);
            });
    }
};

/*
export const getters = {
    slotsByDay: (state) => {
        const days = [];
        for (let i = 0, max = state.slots.length; i < max; i++) {
            let slot = state.slots[i];
            //console.log(slot);
            if (! (slot.day in days)) {
                days[slot.day] = [];
            }
            days[slot.day].push(slot);
        }
        return days;
    },
};
*/
